/**
 *
 * @author bas.
 */

'use strict';

var tools = {};

tools = {
    session: {
        token: 'Bearer 2173.4591c9d87993c9c3ad60c6018979944c',
        userId: '2048'
    },
    // convert bytes to readable size
    convert: function ( size ) {
        if ( (!size && size !== 0) || size < 0 ) { return 'n/a'; }
        if ( size > (1024 * 1024 * 1024) ) {
            return (Math.floor(size / 1024 / 1024 / 1024 * 100) / 100) + ' ' + gettext('GB');
        }
        if ( size > (1024 * 1024) ) {
            return (Math.floor(size / 1024 / 1024 * 100) / 100) + ' ' + gettext('MB');
        }
        if ( size > (1024) ) {
            return (Math.floor(size / 1024 * 100) / 100) + ' ' + gettext('KB');
        }

        return size + ' ' + gettext('B');
    },
    // convert time to readable date
    parseDate: function parseDate ( from ) {
        var months = [
                gettext('Jan'),
                gettext('Feb'),
                gettext('Mar'),
                gettext('Apr'),
                gettext('May'),
                gettext('Jun'),
                gettext('Jul'),
                gettext('Aug'),
                gettext('Sep'),
                gettext('Oct'),
                gettext('Nov'),
                gettext('Dec')
            ],
            day     = from.getDate(),
            month   = from.getMonth(),
            minutes = from.getMinutes(),
            hours   = from.getHours();

        return day + ' ' + months[month] + ' ' + (hours > 9 ? hours : '0' + hours) + ':' + (minutes > 9 ? minutes : '0' + minutes);
    },
    dates: {
        hours: (function () {
            var arr = [],
                index;

            for ( index = 0; index <= 23; index++ ) { arr.unshift(index < 10 ? '0' + index : String(index)); }

            return arr;
        })(),
        minutes: (function () {
            var arr = [],
                index;

            for ( index = 0; index <= 59; index++ ) { arr.unshift(index < 10 ? '0' + index : String(index)); }

            return arr;
        })(),
        days: (function () {
            var arr = [],
                index;

            for ( index = 1; index <= 31; index++ ) { arr.unshift(index < 10 ? '0' + index : String(index)); }

            return arr;
        })(),
        months: (function () {
            var arr = [],
                index;

            for ( index = 1; index <= 12; index++ ) { arr.unshift(index < 10 ? '0' + index : String(index)); }

            return arr;
        })(),
        years: [String((new Date()).getFullYear()), String((new Date()).getFullYear() + 1)]
    }
};


module.exports = tools;
